import {Environment} from '../constants';

export const appVersion = Environment.version?.split(' ')[0];
